// Externe Bibliotheken
import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// Interne Module
import { convertPrice } from '@/_helper/mapper';
import markerIcon from '@/assets/img/assets/map/marker.png';

// Styles
import './map.scss';

export function MapOverlayContainer(props) {
    const [done, setDone, theMap, setMap] = useState(false);
    const markerRefs = useRef({});

    useEffect(() => {
        let id = props.popup;
        if (id && done) {
            const markerToOpen = markerRefs.current[id];
            if (markerToOpen !== undefined && markerToOpen !== null) {
                markerToOpen.openPopup();
            }
        }
    }, [theMap, done, props.popup, props.offers]);

    function marker() {
        if (props.offers === undefined) {
            return false;
        }

        let icon = L.icon({
            iconUrl: markerIcon,
            iconSize: [24, 32],
            iconAnchor: [12, 22],
            popupAnchor: [0, -15],
        });

        let items = [];

        Object.keys(props.offers).forEach((k) => {
            const { latitude, longitude, title, images, price, supplierOfferId } = props.offers[k];
            items.push(
                <Marker
                    position={[latitude, longitude]}
                    icon={icon}
                    key={k}
                    ref={(ref) => {
                        markerRefs.current[k] = ref;
                        if (parseInt(k) === parseInt(Object.keys(props.offers).length - 1) && !done) {
                            setDone(true);
                        }
                    }}>
                    <Popup>
                        {images !== undefined && (
                            <div className="image">
                                <LazyLoadImage
                                    src={images[0].replace(/original/gi, 'display')}
                                    alt={title}
                                    effect="opacity"
                                />
                            </div>
                        )}
                        <div className="content">
                            <div className="title">{title}</div>

                            <div className="txtR">
                                <Link
                                    to={`/ausfluege/details/${supplierOfferId}`}
                                    className="total-price"
                                    target="_blank">
                                    <div>
                                        <span>ab</span> {price.pricePerPerson >= 0 ? '+' : '-'}{' '}
                                        {convertPrice(price.pricePerPerson, 0, 0)}
                                    </div>
                                    <div className="small-print">pro Person</div>
                                </Link>
                            </div>
                        </div>
                    </Popup>
                </Marker>
            );
        });

        return <>{items}</>;
    }

    function mapview() {
        // bounds
        const outerBounds = [];
        Object.keys(props.offers).forEach((k) => {
            const { latitude, longitude } = props.offers[k];
            outerBounds.push([latitude, longitude]);
        });

        // scrollWheelZoom
        let scrollWheelZoom = true;
        if (window.$browserInfo.device === 'mobile') {
            scrollWheelZoom = false;
        }

        const Container = (
            <MapContainer
                whenCreated={(theMap) => setMap(theMap)}
                id="map"
                bounds={outerBounds}
                boundsOptions={{ padding: [20, 20] }}
                zoom={13}
                scrollWheelZoom={scrollWheelZoom}>
                <TileLayer
                    accessToken="pk.eyJ1IjoicGhpbGlwcHVuZ2VyIiwiYSI6ImNsMWM3MzZpdjA0cWgzY28wZnYxNTV0aTIifQ.inNkDMIp0kZ9Qu0N7Y1qkg"
                    id="mapbox/streets-v11"
                    attribution='Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>'
                    url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
                />
                {marker()}
            </MapContainer>
        );

        return (
            <>
                {window.$browserInfo.device === 'mobile' ? (
                    <div className="overlay active map mobile">
                        <span
                            className="close"
                            onClick={(e) => {
                                props.handleHideMap(false);
                            }}>
                            zurück
                        </span>
                        <div className="main-content">{Container}</div>
                    </div>
                ) : (
                    <>
                        <div className="map-section desktop">
                            <div
                                className="close"
                                onClick={(e) => {
                                    props.handleHideMap(false);
                                }}>
                                <i className="material-icons">close</i>
                            </div>
                            {Container}
                        </div>
                    </>
                )}
            </>
        );
    }

    if (props.offers === undefined) {
        return false;
    }

    return <>{mapview()}</>;
}

export function Map(props) {
    const [done, setDone, theMap, setMap] = useState(false);
    const markerRefs = useRef({});

    useEffect(() => {
        let id = props.popup;
        if (id && done) {
            const markerToOpen = markerRefs.current[id];
            if (markerToOpen !== undefined && markerToOpen !== null) {
                markerToOpen.openPopup();
            }
        }
    }, [theMap, done, props.popup, props.location]);

    function marker() {
        if (props.location === undefined) {
            return false;
        }

        let icon = L.icon({
            iconUrl: markerIcon,
            iconSize: [24, 32],
            iconAnchor: [12, 22],
            popupAnchor: [0, -15],
        });

        let items = [];

        const { latitude, longitude, title, images } = props.location;
        if (latitude && longitude) {
            items.push(
                <Marker
                    position={[latitude, longitude]}
                    icon={icon}
                    key={0}
                    ref={(ref) => {
                        markerRefs.current = ref;
                        if (props.location && !done) {
                            setDone(true);
                        }
                    }}>
                    {images && images[0] && (
                        <div className="image">
                            <LazyLoadImage
                                src={images[0].replace(/original/gi, 'display')}
                                alt={title}
                                effect="opacity"
                            />
                        </div>
                    )}
                </Marker>
            );
        }

        return <>{items}</>;
    }

    function mapview() {
        // bounds
        const outerBounds = [];
        const { latitude, longitude } = props.location;
        outerBounds.push([latitude, longitude]);

        // scrollWheelZoom
        let scrollWheelZoom = true;
        if (window.$browserInfo.device === 'mobile') {
            scrollWheelZoom = false;
        }

        const Container = (
            <MapContainer
                whenCreated={(theMap) => setMap(theMap)}
                id="map"
                bounds={outerBounds}
                boundsOptions={{ padding: [20, 20] }}
                zoom={13}
                scrollWheelZoom={scrollWheelZoom}>
                <TileLayer
                    accessToken="pk.eyJ1IjoicGhpbGlwcHVuZ2VyIiwiYSI6ImNsMWM3MzZpdjA0cWgzY28wZnYxNTV0aTIifQ.inNkDMIp0kZ9Qu0N7Y1qkg"
                    id="mapbox/streets-v11"
                    attribution='Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>'
                    url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
                />
                {marker()}
            </MapContainer>
        );

        return (
            <>
                {window.$browserInfo.device === 'mobile' ? (
                    <div className="overlay active map mobile">
                        <div className="main-content">{Container}</div>
                    </div>
                ) : (
                    <>{Container}</>
                )}
            </>
        );
    }

    return <>{mapview()}</>;
}
